/**
 * Persists admin CRM workspace (tenant) for API calls via X-Tenant-Id.
 * Empty/absent = server resolves tenant from session claims only.
 */
const STORAGE_KEY = "tradevault_admin_workspace_tenant_id";

export const ADMIN_WORKSPACE_TENANT_CHANGED_EVENT = "tradevault_admin_workspace_tenant_changed";

function notifyWorkspaceTenantChanged(): void {
  try {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event(ADMIN_WORKSPACE_TENANT_CHANGED_EVENT));
    }
  } catch {
    /* ignore */
  }
}

export function getAdminWorkspaceTenantId(): string | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY)?.trim();
    return v || null;
  } catch {
    return null;
  }
}

export function setAdminWorkspaceTenantId(tenantId: string | null | undefined): void {
  try {
    const t = tenantId?.trim();
    if (!t) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, t);
    notifyWorkspaceTenantChanged();
  } catch {
    /* ignore */
  }
}
